// @ts-strict-ignore
import {ChangeDetectorRef, Component, inject, Input, OnInit} from "@angular/core";
import {OperatorChecklist, ScenarioRecording, TrainingSession} from "@models";
import {SimChecklistService, TrackByMethods} from "@services";
import {Translations} from "@translations";
import {DetachableChangeDetection} from "../panel-components/detachable-cd/detachable-change-detection";
import {AssessablePanelMode} from "@common/components/assessment/utils";

@Component({
	selector: "sim-operator-panel",
	templateUrl: "./operator-panel.component.html",
	styleUrls: ["./operator-panel.component.scss"],
	standalone: false,
})
export class OperatorPanelComponent implements OnInit, DetachableChangeDetection {
	// Enums
	protected readonly T = Translations;
	protected readonly TrackByMethods = TrackByMethods;
	protected readonly AssessablePanelMode = AssessablePanelMode;

	@Input() trainingSession: TrainingSession;
	@Input() scenarioRecording: ScenarioRecording;
	@Input() isInArchive: boolean;

	public checklists: OperatorChecklist[] = [];
	public selectedTabIndex: number = 0;

	private changeDetector = inject(ChangeDetectorRef);
	private _simChecklistService = inject(SimChecklistService);

	public async ngOnInit() {
		const scenarioRecordingMap = this.trainingSession.scenarioRecordingGroups
			.flatMap((g) => g.scenarioRecordingsMap)
			.find((g) => g.scenarioRecordingId === this.scenarioRecording.id);

		if (scenarioRecordingMap?.operatorChecklistIds) {
			this.checklists = await this._simChecklistService.getOperatorChecklistsByIds(scenarioRecordingMap.operatorChecklistIds);
		}
	}

	public attachToCD() {
		this.changeDetector.reattach();
	}

	public detachFromCD() {
		this.changeDetector.detach();
	}
}
